module.exports = __webpack_public_path__ + "media/images/new_landing/favicon/favicon-16x16-e171c54f09c213ed1472e5f591c5f7fa.png";